import flatpickr from "flatpickr";
flatpickr(".flatpickr");